export const endSession = context => id => ({
    type: 'WITNESS.SESSION.END',
    payload: {id},
    context
});